import { useSearchPublicOrder } from "@babackapp/private-api-client/client/use-search-public-order";

export function useSearchOrder() {
  return useSearchPublicOrder();
}
